define('plugin/product/collection/ProductCategoryCollection',['require','lib/collection/BaseCollection','plugin/product/model/ProductCategoryModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var ProductCategoryModel = require('plugin/product/model/ProductCategoryModel');

    return BaseCollection.extend({

        url: '/ext/product/categories/',
        model: ProductCategoryModel

    });

});
